import { render } from "./link-succeed-dialog.vue?vue&type=template&id=7b469fae&scoped=true&ts=true"
import script from "./link-succeed-dialog.vue?vue&type=script&lang=ts"
export * from "./link-succeed-dialog.vue?vue&type=script&lang=ts"

import "./link-succeed-dialog.vue?vue&type=style&index=0&id=7b469fae&lang=less&scoped=true"

import exportComponent from "/opt/jenkins/workspace/WF-cloud-admin-beta/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7b469fae"]])

export default __exports__